import { CartClassName, CartItemDataAttribute } from "./types";

/**
 * Reads current cart state from the DOM for GA4 purposes
 */
export function getCartItemsForDataLayer(): SaAnalyticsUtils.DataLayerCheckoutItem[] {
    try {
        return $(`.${CartClassName.CartItem}`)
            .toArray()
            .map((cartItem) => buildCheckoutItemFromCartElement($(cartItem)))
            .filter((item) => item.price && item.item_name); // exclude the 2 year free membership cart item for logged in users
    } catch (error) {
        console.error("Error reading cart items for data layer:", error);
        return [];
    }
}

/** build GA4 schema data */
export function buildCheckoutItemFromCartElement(
    cartItem: JQuery<HTMLElement>,
): SaAnalyticsUtils.DataLayerCheckoutItem {
    const cartItemProductId = cartItem.data(CartItemDataAttribute.CartItemId);
    const cartItemDescription = cartItem.data(
        CartItemDataAttribute.Description,
    );
    const rawPrice = cartItem.data(CartItemDataAttribute.Price);
    const cartItemPrice = SaNumberUtils.coerceToFloat(rawPrice);
    const cartItemQuantity = cartItem.data(CartItemDataAttribute.Quantity);
    const cartItemDiscount = cartItem.data(
        CartItemDataAttribute.DiscountAmount,
    );
    const analyticsData: SaAnalyticsUtils.DataLayerCheckoutItem = {
        item_id: String(cartItemProductId),
        price: cartItemPrice,
        item_name: cartItemDescription,
        quantity: cartItemQuantity,
    };

    if (cartItemDiscount) {
        analyticsData.discount = cartItemDiscount;
    }

    return analyticsData;
}

/** view_cart event on cart page load */
export function fireDataLayerViewCartEvent() {
    if (window.location.pathname.endsWith("/cart")) {
        const initCartItems = getCartItemsForDataLayer();
        SaAnalyticsUtils.addToDataLayer(
            SaAnalyticsUtils.buildViewCartEventFromItems(initCartItems),
        );
    }
}
